import React from 'react'
import { AdminBarContainer, ButtonLink, SearchSection } from './AdminBar.styles'
import { Text } from '@awazevr/design-system.components.text'
import { useQueryUserAuthorisations } from '@/hooks/useQuery/queries/useQueryUserAuthorisations'

const AdminBar = () => {

  const { data: userAuthorisations } = useQueryUserAuthorisations()

  const isEmployee = userAuthorisations?.some(auth => auth.name === 'employee' && auth.authorised)

  if (!isEmployee) return null

  return (
    isEmployee &&
    <AdminBarContainer data-testid="admin-bar">
      <SearchSection>
        <ButtonLink to="/admin" data-testid="admin-link">
          <Text sizes={[100, 300, 300]} mb={0} color="currentColor">Admin</Text>
        </ButtonLink>
      </SearchSection>
    </AdminBarContainer>
  )
}

export default AdminBar
